<section>
    <app-vca-filter [pageId]="pageId" [modes]="modes" [userInfos]="userInfos" (filterDataOutputEvent)="filterUploadContent($event)"
    style="padding: 8px;"></app-vca-filter>
    
    <app-upload-content #appUploadContent [platformInfos]="platformInfos"></app-upload-content>
  </section>